// same as database
export enum ImageCategory {
  BackgroundImages = 'Background images',
  // SpecificImages = 'Specific images',
  // Icons = 'Icons',
  DigitalBadges = 'Digital badges',
  OtherImages = 'Other images',
}
